import React, { useState,useEffect } from "react";
import {useDimensions} from "../../../Util";
import GoogleAuth from "../../../GoogleAuth/GoogleAuth";
import { useNavigate } from "react-router-dom";
import { updatePaUser} from "../../../UtilComps/Crud";
import Spinner  from "../../../UtilComps/Spinner";

const YesNoContainer = ({id,image,question,setContentId,setUser,setBearerToken}) => {

    const {w,h} = useDimensions();
    //setProaddictiveUser&setToken will be executed in google auth component
    const [proaddictiveUser,setProaddictiveUser] = useState(JSON.parse(sessionStorage.getItem("proaddictive-user"))||JSON.parse(localStorage.getItem("proaddictive-user")));
    const [token,setToken]=useState(JSON.parse(sessionStorage.getItem("bearer-token"))||JSON.parse(localStorage.getItem("bearer-token")));
    const [showLogin,setShowLogin]=useState(false);
    const [isYesClicked,setIsYesClicked]=useState(false);
    const [isActivityUpdated,setIsActivityUpdated]=useState(false);
    const [showSpinner,setShowSpinner] = useState(false);

    const navigate = useNavigate();

    useEffect(()=>{
        proceed();
    },[proaddictiveUser,isYesClicked,isActivityUpdated])


    const proceed = async () => {
        if(isYesClicked){
            if(proaddictiveUser===null){
                setShowLogin(true);
            }else{
                localStorage.setItem("proaddictive-user",JSON.stringify(proaddictiveUser));
                localStorage.setItem("bearer-token",JSON.stringify(token));
                sessionStorage.setItem("bearer-token",JSON.stringify(token));
                sessionStorage.setItem("proaddictive-user",JSON.stringify(proaddictiveUser));
                setUser(proaddictiveUser);
                setBearerToken(token);
                if(!isActivityUpdated){
                    let userActivity = [];
                    userActivity = Array.isArray(proaddictiveUser?.activity) ? proaddictiveUser.activity : [];
                    const newActivityItem = id + "-yes";
                    userActivity.push(newActivityItem);
                    proaddictiveUser.activity = userActivity.map(item => String(item));
                    setShowSpinner(true);
                    let response = await updatePaUser({ bearerToken: token, user: proaddictiveUser });
                    if(response.message==="User updated successfully"){
                        setIsActivityUpdated(true)
                        setShowSpinner(false);
                    }
                } else {
                    setContentId("penPunContainer")
                }
            }
        }
    }

    const styles = {
        container:{
            width:"100%",
            height:"100%",
            display:"flex",
            justifyContent:"center",
            alignItems:"center",
            flexDirection:"column",
            gap:"10px"
        },
        image:{
            width: w > h ? 20 * h : 14 * h,
            height: w > h ? 20 * h : 14 * h,
        },
        largeTextBold:{
            fontFamily: "Candal",
            fontSize:w>h?"clamp(28px,3vw,35px)":"clamp(28px,3vh,35px)"
        },
        yesNoBtns:{
            marginTop:3*h
        },
        yesBtn:{
            padding: "7px",
            background: "#00ADB5",
            color: "#EEEEEE",
            border: "2px solid #EEEEEE",
            borderRadius: w > h ? w : h,
            fontSize: 2 * h,
            fontFamily: "Candal",
            marginInline: "5px",
            cursor: "pointer"
        },
        noBtn:{
            padding: "7px",
            background: "#FF2E63",
            color: "#EEEEEE",
            border: "2px solid #EEEEEE",
            borderRadius: w > h ? w : h,
            fontSize: 2 * h,
            fontFamily: "Candal",
            marginInline: "5px",
            cursor: "pointer"
        },
        flexDivRow:{
            display:"flex",
            justifyContent:"center",
            alignItems:"center",
            marginTop:"10px"
        }
    }

    const yesClicked=()=>{
        setIsYesClicked(true);
    }

    const noClicked = () => {
        navigate("/")
    };
    


    return <div id="yes-no-container" style={styles.container}>
        <img src={`/images/${image}`} style={styles.image} alt="Description" />
        <p style={styles.largeTextBold}>{question}</p>
        <div id="yes-no-btns" style={styles.yesNoBtns}>
            <button onClick={noClicked} style={styles.noBtn}>No</button>
            <button onClick={yesClicked} style={styles.yesBtn}>Yes</button>
            {showLogin&&(
                <GoogleAuth setProaddictiveUser={setProaddictiveUser} setToken={setToken}></GoogleAuth>
            )}
            <div style={styles.flexDivRow}>
                {
                    showSpinner&&(
                        <Spinner size={w>h?5*w:5*h}></Spinner>
                    )
                }
            </div>
        </div> 
    </div>
}

export default YesNoContainer;